/**
 * popupSpacing - keeps Worthly's big pop-ups (review ask, Money Club invite)
 * from landing on back-to-back app opens.
 *
 * Whichever pop-up shows first, the other has to wait until at least
 * GAP app opens later. Open count is the same one the review prompt uses
 * (counted once per app session). Stored on the phone only.
 */
import { reviewService } from "../services/reviewService";

const KEY = 'worthly_last_popup';
const GAP = 2;

export const canShowPopup = (id) => {
  try {
    const last = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!last) return true;
    const opens = reviewService.getOpenCount();
    // The pop-up already showing this session can stay up.
    if (last.id === id && last.open === opens) return true;
    return opens >= last.open + GAP;
  } catch (e) {
    return true;
  }
};

export const markPopupSpacing = (id) => {
  try {
    localStorage.setItem(KEY, JSON.stringify({ id, open: reviewService.getOpenCount() }));
  } catch (e) {
    // Storage unavailable - nothing to space against.
  }
};
